export default __webpack_public_path__ + "static/media/Create-Ticket.390c0347.png";